<template>
  <form>
    <vue-element-loading :active="loading" spinner="spinner"/>
    <h4>General</h4>
    <b-form-group label="Timezone for reports">
      <b-form-select :options="timeZones.nodes" v-model="timezone" />
    </b-form-group>

    <div class="form-group">
      <label class="font-weight-bold">Avatar</label>
      <p class="ml-2">Your avatar originates from <a href="https://www.gravatar.com/" target="_blank">Gravatar <i class="fa fa-external-link" /></a>.</p>
    </div>

    <div class="form-group">
      <label class="font-weight-bold">Advanced items</label>
      <p class="ml-2">
        <b-form-checkbox v-model="itemAccessLevel" :value="1" :unchecked-value="0">
        Enable advanced items in data analysis
        </b-form-checkbox>
      </p>
    </div>

    <h4>Graphical display</h4>
    <div class="form-group">
      <label class="font-weight-bold">Graph resolution</label>
      <div class="ml-2">Use <input type="number" class="form-control width-auto d-inline" max="20" min="0.5" step="any"
                                   v-model.number="graphPpdp"> pixel(s) per data point</div>
    </div>
  </form>

</template>

<script>
import gql           from 'graphql-tag';
import {CACHE_FIRST} from '@/lib/constants';
import store2        from '@/lib/store2';

export default
{
    apollo:
    {
        timeZones:
        {
            query: require('../gql/listTimezones.gql'),
            fetchPolicy: CACHE_FIRST
        }
    },
    computed:
    {
        $state() { return store2(this.$pinia) }
    },
    data()
    {
        return {
            timeZones: {},
            loading: true,
            // User settings
            graphPpdp: 3,
            itemAccessLevel: 0,
            timezone: 'UTC'
        }
    },
    methods:
    {
        save()
        {
            return this.$state.updateSettings(
                this,
                {
                  graphPpdp: this.graphPpdp,
                  itemAccessLevel: this.itemAccessLevel,
                  timezone: this.timezone
                }
            );
        }
    },
    async created()
    {
        this.loading = true;

        try
        {
            const {data: {whoAmI}} = await this.$apollo.query(
                {
                    query: gql`{whoAmI{ id timezone itemAccessLevel graphPpdp }}`
                }
            );

            this.timezone         = whoAmI.timezone;
            this.itemAccessLevel  = whoAmI.itemAccessLevel;
            this.graphPpdp        = whoAmI.graphPpdp;
        }
        catch (e)
        {
            console.error(e);
        }
        finally
        {
            this.loading = false;
        }
    }
}
</script>

